import React from "react";
import { Check } from "lucide-react";

const STEPS = [
  { title: "Create your profile", desc: "You're signed in — your concierge is ready.", done: true },
  { title: "Set your business dates", desc: "Add key dates to your calendar with reminders." },
  { title: "Generate a lifestyle plan", desc: "Use the AI planner for a tailored itinerary." },
  { title: "Save & book", desc: "Collect destinations, trips and services you love." },
  { title: "Order & live", desc: "Shop via Temu & Shein centers and enjoy MOVA." },
];

export const Roadmap = ({ completed = {} }) => (
  <div data-testid="dashboard-roadmap">
    <h2 className="font-serif text-2xl sm:text-3xl text-white mb-8">Your MOVA Roadmap</h2>
    <div className="relative pl-8">
      <div className="absolute left-[11px] top-2 bottom-2 w-px bg-gradient-to-b from-amber-400/60 to-white/5" />
      <div className="space-y-7">
        {STEPS.map((s, i) => {
          const done = s.done || completed[i];
          return (
            <div key={i} className="relative" data-testid={`roadmap-step-${i}`}>
              <span className={`absolute -left-8 top-0 w-6 h-6 rounded-full flex items-center justify-center border ${done ? "bg-gradient-to-r from-[#F3E5AB] to-[#D4AF37] border-transparent text-[#1a1a12]" : "border-amber-400/40 bg-[#101017] text-slate-500"}`}>
                {done ? <Check size={13} /> : <span className="text-[11px]">{i + 1}</span>}
              </span>
              <h4 className={`font-medium ${done ? "text-champagne" : "text-white"}`}>{s.title}</h4>
              <p className="text-sm text-slate-400 mt-1">{s.desc}</p>
            </div>
          );
        })}
      </div>
    </div>
  </div>
);
